import CampaignsIcon from 'components/sidebar/icons/campaigns-icon';
import { ContentLayout, PageLayout } from 'layout';
import { useContext, useMemo } from 'react';
import CampaignsDashboardHeader from './CampaignsDashboardHeader';
import CampaignsDashboardTable from './CampaignsDashboardTable';
import useCampaignsDashboard from './useCampaignsDashboard';
import { AuthContext } from '@urbanx/agx.auth.client';

const CampaignsDashboard = () => {
  const { userAccount } = useContext(AuthContext);
  const {
    rows,
    agencyLookup,
    isPending,
    isAgenciesPending,
    lastRowRef,
    addressSearchText,
    agencyFilterOptions,
    selectedStateOptions,
    selectedCampaignStatusOptions,
    selectedContractStatusOptions,
    selectedLaunchDateStatusOptions,
    selectedMarketingStatusOptions,
    setAddressSearchText,
    handleStateFilterSelect,
    handleAgencyFilterSelect,
    handleCampaignStatusFilterSelect,
    handleContractFilterSelect,
    handleLaunchDateFilterSelect,
    handleMarketingFilterSelect,
    resetAgencyFilters,
    resetStateFilters,
    resetCampaignStatusFilters,
    resetContractFilters,
    resetLaunchDateFilters,
    resetMarketingFilters,
    onSortLaunch,
  } = useCampaignsDashboard();

  const userName = useMemo(() => {
    return [userAccount?.firstName, userAccount?.lastName]
      .filter((namePart) => namePart != null && namePart.length > 0)
      .join(' ');
  }, [userAccount]);

  return (
    <PageLayout
      agentName={userName}
      primaryPageTitle="Campaigns"
      pageIcon={
        <div className="iconContainer">
          <CampaignsIcon height="28" width="28" />
        </div>
      }
      header={
        <CampaignsDashboardHeader
          addressSearchText={addressSearchText}
          agencyFilterOptions={agencyFilterOptions}
          selectedStateOptions={selectedStateOptions}
          selectedCampaignStatusOptions={selectedCampaignStatusOptions}
          selectedContractStatusOptions={selectedContractStatusOptions}
          selectedLaunchDateStatusOptions={selectedLaunchDateStatusOptions}
          selectedMarketingStatusOptions={selectedMarketingStatusOptions}
          onAddressSearchTextChange={setAddressSearchText}
          handleStateFilterSelect={handleStateFilterSelect}
          handleAgencyFilterSelect={handleAgencyFilterSelect}
          handleCampaignStatusFilterSelect={handleCampaignStatusFilterSelect}
          handleContractFilterSelect={handleContractFilterSelect}
          handleLaunchDateFilterSelect={handleLaunchDateFilterSelect}
          handleMarketingFilterSelect={handleMarketingFilterSelect}
          resetAgencyFilters={resetAgencyFilters}
          resetStateFilters={resetStateFilters}
          resetCampaignStatusFilters={resetCampaignStatusFilters}
          resetContractFilters={resetContractFilters}
          resetLaunchDateFilters={resetLaunchDateFilters}
          resetMarketingFilters={resetMarketingFilters}
        />
      }
    >
      <ContentLayout hasSecondaryMenu={false}>
        <CampaignsDashboardTable
          rows={rows}
          agencyLookup={agencyLookup}
          isPending={isPending}
          isAgenciesPending={isAgenciesPending}
          lastRowRef={lastRowRef}
          onSortLaunch={onSortLaunch}
        />
      </ContentLayout>
    </PageLayout>
  );
};

export default CampaignsDashboard;
